import React from 'react';
import { Package2, TrendingUp, Wallet, Clock, Search } from 'lucide-react';

function WholesaleDashboard() {
  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Личный кабинет</h1>
          <p className="mt-1 text-sm text-gray-500">
            Добро пожаловать, ООО "Компания"
          </p>
        </div>

        {/* Search */}
        <div className="mb-8">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Поиск по заказам..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0171E3] focus:border-transparent"
            />
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          {[
            { label: 'Активные заказы', value: '5', icon: Package2, color: 'bg-blue-500' },
            { label: 'Общий объем', value: '¥125,000', icon: TrendingUp, color: 'bg-green-500' },
            { label: 'Баланс', value: '¥15,000', icon: Wallet, color: 'bg-yellow-500' },
            { label: 'В пути', value: '3', icon: Clock, color: 'bg-purple-500' }
          ].map((stat, index) => (
            <div key={index} className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className={`${stat.color} rounded-full p-3`}>
                  <stat.icon className="w-6 h-6 text-white" />
                </div>
                <div className="ml-4">
                  <div className="text-2xl font-semibold text-gray-900">{stat.value}</div>
                  <div className="text-sm text-gray-500">{stat.label}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Orders */}
          <div className="lg:col-span-2 bg-white rounded-lg shadow">
            <div className="p-6">
              <h2 className="text-lg font-medium text-gray-900 mb-4">Мои заказы</h2>
              <div className="space-y-4">
                {[...Array(5)].map((_, index) => (
                  <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                    <div>
                      <div className="font-medium">Заказ #{202400 + index}</div>
                      <div className="text-sm text-gray-500">
                        {['В обработке', 'Оплачен', 'В пути', 'На складе', 'Доставлен'][index]}
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-[#0171E3]">¥ {(1500 + index * 500).toLocaleString()}</div>
                      <div className="text-sm text-gray-500">{`${index + 1} дн. назад`}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="space-y-8">
            <div className="bg-white rounded-lg shadow p-6">
              <h2 className="text-lg font-medium text-gray-900 mb-4">Быстрые действия</h2>
              <div className="space-y-4">
                <button className="w-full bg-[#0171E3] text-white py-2 px-4 rounded-lg hover:bg-[#0156aa] transition-colors">
                  Новый заказ
                </button>
                <button className="w-full bg-gray-100 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-200 transition-colors">
                  Пополнить баланс
                </button>
                <button className="w-full bg-gray-100 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-200 transition-colors">
                  Техподдержка
                </button>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <h2 className="text-lg font-medium text-gray-900 mb-4">Уведомления</h2>
              <div className="space-y-4">
                {[
                  'Заказ #202404 прибыл на склад',
                  'Изменение статуса заказа #202403',
                  'Новый курс юаня: 12.5 ₽'
                ].map((notification, index) => (
                  <div key={index} className="text-sm text-gray-700 pb-2 border-b border-gray-100">
                    {notification}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WholesaleDashboard;